import environment from "../environment";

export const getBokunKey = (domain) => {
  if (!domain || typeof domain !== "string") {
    console.warn("Invalid domain provided to getBokunKey");
    return ''
  }

  const keyName = `bokunAppApiKey_${domain.trim().toLowerCase().replace(/-/g, "")}`;
  const key = ''

  if (key) {
    return key;
  }
  
  console.warn(`Custom Bokun key for domain "${domain}" not found. Using default.`);
  return ''
};
